import { Route } from 'types/route.type';
import { routes as palette } from './features/palette/routes';
import { routes as playground } from './features/playground-base/routes';
import { routes as mySupplyPlan } from './features/my-supply-plan/routes';
import { routes as scenarioPlan } from './features/scenario-planner-2.0/routes';
import { routes as dataLab } from './features/data-lab/routes';
import { routes as bluViuNutritionR2 } from './features/bluviu-nutrition-r2/routes';


export const routes: Route[] = [...playground, ...palette, ...mySupplyPlan, ...scenarioPlan, ...dataLab, ...bluViuNutritionR2];
